import { render } from "./CaptionProviderBanner.vue?vue&type=template&id=06312e80"
import script from "./CaptionProviderBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptionProviderBanner.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/CaptionProviderBanner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06312e80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06312e80', __exports__)) {
    api.reload('06312e80', __exports__)
  }
  
  module.hot.accept("./CaptionProviderBanner.vue?vue&type=template&id=06312e80", () => {
    api.rerender('06312e80', render)
  })

}


export default __exports__